import React from 'react';
import { useTranslation } from 'react-i18next';
import ClientLoadingIcon from '../../../components/client-components/client-loading-icon';
import ClientSystemStatusUI from '../../../components/client-components/client-system-status-ui';
import './style.styl';

const PREFIX_CLASS = 'client-loading-page-status';
const LoadingPageStatus = () => {
	const { t } = useTranslation();

	return (
		<div className={PREFIX_CLASS}>
			<ClientSystemStatusUI
				content={
					<div className={`${PREFIX_CLASS}__container`}>
						<ClientLoadingIcon className={`${PREFIX_CLASS}__loading`} />
						<div>{t('页面正在加载中')}</div>
						<div className="sub-content">{t('这可能需要几分钟的时间，请耐心等待')}</div>
					</div>
				}
			/>
		</div>
	);
};

export default LoadingPageStatus;
